export default __webpack_public_path__ + "locales/fi/People.json?hash=b7ce1520ace74a72542f6ee744e003a6";